import * as React from 'react'
import { Box, Button, MenuList, useMediaQuery } from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'
import navConfig from './config'
import NavigationLink from './NavigationLink'
import { type SetStateAction } from 'react'
import useIHFlink from '../../../../hooks/useIHFlink'
import useToken from '../../../../hooks/useToken'
import useStudioLink from '../../../../hooks/useStudioLink'
import LinkSvg from './LinkSvg'
import navConfigHome from './configHome'
import PopOverManageWebsite from './PopOverManageWebsite'
import navConfigLocalPresence from './configLocalPresence'
import type { IUserProfile } from '../../../../redux/api/types'
import { useSelector } from 'react-redux'
import { isLocalPresenceCountry } from '../../../../utils/isLocalPresenceCountry'

const NavButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  '&:hover': {
    color: theme.palette.grey[50]
  }
}))
const NavButtonMobile = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  color: theme.palette.primary.contrastText,
  ml: '4px',
  '&:hover': {
    color: theme.palette.grey[50]
  }
}))

export default function Navigation ({ setMobileOpen }: { setMobileOpen?: React.Dispatch<SetStateAction<boolean>> }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const { xsrf } = useToken()
  const { openIHFDashboard } = useIHFlink(xsrf)
  const { openDesignStudioDashboard } = useStudioLink(xsrf)
  const user: IUserProfile = useSelector((state: any) => state.userState.user)
  const isLocalPresence: boolean = user.permissions.localPresence && user.yextUserId !== null && user.yextUserId !== '' && isLocalPresenceCountry(user) && !user.isPaymentPastDue
  const isDesignStudio: boolean = user.permissions.designStudio && !user.isPaymentPastDue

  return (
    <Box sx={{ flexGrow: isMobile ? '0' : '1' }} >
        <MenuList
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'center',
            alignItems: isMobile ? 'left' : 'center',
            [theme.breakpoints.down('lg')]: {
              display: 'flex',
              gap: '20px',
              flexDirection: 'column',
              m: '20px 0'
            }
          }}
        >
            {navConfigHome().map(item =>
                <NavigationLink
                    key={item.title}
                    path={item.path}
                    title={item.title}
                    setMobileOpen={setMobileOpen}
                />
            )}
            {
              user?.account.websiteUrl
                ? <PopOverManageWebsite/>
                : null
            }
            {
              isLocalPresence
                ? (navConfigLocalPresence().map(item =>
                  <NavigationLink
                    key={item.title}
                    path={item.path}
                    title={item.title}
                    setMobileOpen={setMobileOpen}
                  />))
                : ''
            }
            {navConfig().map(item =>
              <NavigationLink
                key={item.title}
                path={item.path}
                title={item.title}
                setMobileOpen={setMobileOpen}
                />
            )}
            {
                isMobile
                  ? (<>
                      <NavButtonMobile
                        onClick={openIHFDashboard}
                        disabled={user?.isPaymentPastDue ?? true}
                      >
                        Leads
                        <LinkSvg/>
                      </NavButtonMobile>
                      {
                      isDesignStudio
                        ? (
                        <NavButtonMobile
                          onClick={openDesignStudioDashboard}
                          disabled={!isDesignStudio}
                        >
                          Design Studio
                        <LinkSvg/>
                        </NavButtonMobile>)
                        : null
                      }
                    </>)
                  : (<>
                      <NavButton
                        onClick={openIHFDashboard}
                        disabled={user?.isPaymentPastDue ?? true}
                      >
                        Leads
                        <LinkSvg/>
                      </NavButton>
                      {
                      isDesignStudio
                        ? (
                        <NavButton
                          onClick={openDesignStudioDashboard}
                          disabled={!isDesignStudio}
                        >
                          Design Studio
                          <LinkSvg/>
                        </NavButton>)
                        : null
                      }
                    </>)
            }
        </MenuList>
    </Box>
  )
}
